export default __webpack_public_path__ + "static/media/accesorios.21f82938.jpg";